import React, { useState } from "react"
import UnifiedDatePicker from "../../../components/compounds/UnifiedDatePicker.compound"
import { DateTime } from "luxon"
import SecondaryButton from "../../../components/molecules/buttons/SecondaryButton.molecule"
import { compareDates } from "../../../utils/date.utils"
import { ReactComponent as CalendarTimeIcon } from "../../../design/assests/images/icons/time.svg"
import Tooltip from "../../../components/atoms/Tooltip.atom"
import { generateRandomId } from "../../../utils/strings.utils"
import InputPlaceholderChipTemplate from "../../../components/molecules/InputPlaceholderChipTemplate.molecule"

const ChooseTimeInput = ({
  value,
  onChange,
  label = "Fecha límite",
  name = "limitDate",
  error,
  inputRef,
  selected = false,
  readOnly = false,
  chipClassName = `choose-time-chip-${generateRandomId()}`,
}) => {
  const [isEditing, setIsEditing] = useState(false)
  const minDate = DateTime.local().plus({ hours: 0.5 })
  value = value ? DateTime.fromISO(value) : null
  if (value && value < DateTime.local()) {
    error = true
  }
  const tooltipConfig =
    error || value ?
      {
        "data-pr-tooltip": `Fecha límite${error ? " con retraso" : ""}`,
        "data-pr-position": "bottom",
      }
    : {}
  const containerStyles = {
    width: "105px",
    height: "26px",
  }
  const handleChipClick = () => {
    setIsEditing(true)
    setTimeout(() => {
      inputRef.current?.nativeElement.click()
    }, 100)
  }

  const SelectedDateTemplate = () => {
    return (
      <InputPlaceholderChipTemplate
        highlighted={isEditing}
        selected={readOnly ? false : selected}
        error={error}
        disabled={readOnly}
        className={chipClassName}
        template={
          <span className="p-chip-text text-overflow-ellipsis white-space-nowrap overflow-hidden max-w-12rem flex gap-1 align-items-center">
            <CalendarTimeIcon
              className="flex-shrink-0 clr-text fill-inherit"
              width={14}
              height={14}
            />
            <span>{value?.toFormat("dd/MM/yyyy")}</span>
          </span>
        }
        onClick={handleChipClick}
        {...tooltipConfig}
      />
    )
  }
  const placeholderChipTemplate = () => {
    return (
      <InputPlaceholderChipTemplate
        highlighted={isEditing}
        selected={selected}
        error={error}
        disabled={readOnly}
        className={chipClassName}
        template={
          <span className="p-chip-text text-overflow-ellipsis white-space-nowrap overflow-hidden max-w-12rem flex gap-1 align-items-center">
            {error ?
              <i className="pi pi-exclamation-triangle text-xs line-height-2 m-auto fill-inherit"></i>
            : <CalendarTimeIcon
                className="flex-shrink-0 clr-text fill-inherit"
                width={14}
                height={14}
              />
            }
            <span>{label}</span>
          </span>
        }
        onClick={handleChipClick}
        {...tooltipConfig}
      />
    )
  }

  return (
    ((readOnly && value) || !readOnly) && (
      <div
        key={isEditing}
        className="dropdown-choosettime-inplace input-panel-with-chip"
        style={containerStyles}
      >
        {value ?
          <SelectedDateTemplate />
        : placeholderChipTemplate()}
        <Tooltip target={`.${chipClassName}`} />
        {!readOnly && (
          <UnifiedDatePicker
            dateRange={[value, value || minDate]}
            setDateRange={(e) => onChange(e[1])}
            period="single-datetime"
            hidePeriodSelector
            datePickerWrapperProps={{
              className: "opacity-0 pointer-events-none",
            }}
            datePickerProps={{
              name,
              picker: "datetime",
              popupClassName: "opacity-1",
              className: "opacity-0 overflow-hidden absolute py-0",
              showNow: false,
              showTime: {
                format: "HH:mm",
                minuteStep: 15,
                secondStep: 10,
              },
              minDate: minDate,
              disabledTime: (current) => {
                current = value || current
                if (compareDates(current, minDate)) {
                  return {
                    disabledHours: () => [...Array(minDate.hour).keys()],
                    disabledMinutes: (h) =>
                      h === minDate.hour ?
                        [...Array(minDate.minute).keys()]
                      : [],
                  }
                }
                return {}
              },
              style: {
                height: "25.5px",
              },
              renderExtraFooter: () => (
                <div>
                  <SecondaryButton
                    label="Limpiar"
                    className="absolute ant-clear-btn"
                    onClick={() => {
                      onChange(null)
                    }}
                  />
                </div>
              ),
              ref: inputRef,
              onBlur: (e) => {
                if (
                  Array.from(e.relatedTarget?.classList || []).some((c) =>
                    c.includes("ant")
                  )
                ) {
                  e.preventDefault()
                  e.stopPropagation()
                  return
                }
                setTimeout(() => setIsEditing(false), 300)
              },
            }}
          />
        )}
      </div>
    )
  )
}

export default ChooseTimeInput
